import React, { Component } from 'react';
import { Grid, Row, Col } from 'react-bootstrap';

class AssessmentPoint extends Component {
  render() {
    const { pointsRewarded } = this.props;

    return (
      <Grid className="assessment-point">
        <Row>
          <Col className="text">You have earned</Col>
        </Row>
        <Row>
          <Col className="text-points">
            {pointsRewarded}
            <br/>
            points
          </Col>
        </Row>
      </Grid>
    );
  }
}

export default AssessmentPoint;



// WEBPACK FOOTER //
// ./src/components/assessments/assessment-point.jsx